import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { RequestResponse } from '../intefaces/requestResponse';
import { urls } from './urls';
import { BrowserStorageService } from './storage.service';
import { __APP_STORAGE_CART__ } from '../intefaces/const';

export interface ICounter {
  count: number;
}

@Injectable({
  providedIn: 'root'
})
export class CartService extends BaseService {

  constructor(protected http: HttpClient, protected browserStorageService: BrowserStorageService) {
    super();
  }

  private cartObserver: Subject<any> = new Subject<any>();
  private cartAsyncCounter: Subject<ICounter> = new Subject<any>();
  public cartQuanity: number = 0;

  public addToCart(item: any) {
    return this.cartObserver.next(item);
  }

  public listenCart() {
   return this.cartObserver.asObservable();
  }

  public createOrder(order) {
    return this.http.post<RequestResponse>(this.getUrl('createOrder'), order);
  }

  public storeCart(item: any) {
    return this.http.post<RequestResponse>(this.getUrl('addToCart'), item);
  }

  public storeCartAsArray(items: Array<any>) {
    return this.http.post<RequestResponse>(this.getUrl('addItemsToCart'), items);
  }

  public getMyCart() {
    return this.http.get<RequestResponse>(this.getUrl('getCart'));
  }

  public quantity() {
    return this.http.get<RequestResponse>(this.getUrl('quantityCart'))
  }

  public deleteItemFromCart(item) {
    return this.http.post<RequestResponse>(this.getUrl('deleteItemFromCart'), item);
  }

  public async storeItemsInDb() {
    let items: Array<any> = JSON.parse(this.browserStorageService.get(__APP_STORAGE_CART__)) || [];
    await this.storeCartAsArray(items).toPromise();
    this.browserStorageService.remove(__APP_STORAGE_CART__);
  }

  public getAsyncCountItemsInCart() {
    return this.cartAsyncCounter.asObservable();
  }

  public changeQuantity(count: ICounter) {
    this.cartAsyncCounter.next(count);
  }

}
